import { Navigate } from 'react-router-dom';
import { AppShell } from '../components/AppShell';
import { EmptyState } from '../components/EmptyState';
import { Spinner } from '../components/ui';
import { useTenantContext } from '../hooks/useTenantContext';

/**
 * Entrada de "Métricas" del menú.
 *
 * El dashboard de CRM vive en `/tenants/:tenantId/metrics` porque los datos
 * están scopeados por tenant (regla A1). Pero el menú lateral no tiene un
 * tenant en la URL, así que antes apuntaba a `/conversations/metrics` — la
 * pantalla de Live Chat, que es otra cosa. Esta ruta resuelve el tenant activo
 * y redirige al dashboard correcto.
 */
export function MetricsRedirect() {
  const { activeTenantId, loading } = useTenantContext();

  if (loading) {
    return (
      <AppShell>
        <div className="flex justify-center py-16">
          <Spinner />
        </div>
      </AppShell>
    );
  }

  if (!activeTenantId) {
    return (
      <AppShell>
        <EmptyState message="No hay tenants disponibles para mostrar métricas." />
      </AppShell>
    );
  }

  return <Navigate to={`/tenants/${activeTenantId}/metrics`} replace />;
}
